import * as React from 'react';
import {Box, Typography} from '@mui/material';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { GET_HIRES } from '../../api/hire';

const Mentors = () => {
    const [mentors , setMentors] = React.useState([]);
    React.useEffect(() => {
        axios
        .get(GET_HIRES)
        .then(res => {
            const men = res.data.data.map((mentor , index) => {
                mentor.id = index+1; 
                return mentor;
            });
            
            setMentors(men);
        })
        .catch(err => {
            console.error(err);
        })
    },[]);
    const columns = [
        { field: '_id', headerName: 'ID', width: 90 },
        {
          field: 'fullName',
          headerName: 'Full Name',
          width: 150,
        },
        {
          field: 'designation',
          headerName: 'Designation',
          width: 150,
        },
        {
          field: 'email',
          headerName: 'Email',
          width: 250,
        },
        {
          field: 'whatsappNumber',
          headerName: 'Whatsapp Number',
          width: 160,
        },
        {
            field: 'companyRepresenting',
            headerName: 'Company Representing',
            width: 160,
          },
          {
            field: 'rolesAndPositions',
            headerName: 'Roles And Position',
            width: 160,
          },
      ];

  return (
    <Box>
    <Typography variant='h6' sx={{marginBottom: 3}}>Hire page Entries</Typography>
    <Box sx={{ height: '100vh', width: '100%' }}>
      <DataGrid
        rows={mentors}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
      />
    </Box>
    </Box>
  )
}

export default Mentors